import React, { useState } from "react";
import "./Section1.css";
import "./Section2.css";
import "./Section3.css";
import "./Section4.css";
import "bootstrap/dist/css/bootstrap.min.css";
import illustration from "../Asset/desktop illustration 2.png";
import plusIconBlue from "../Asset/plus icon blue.png";
import tickIconOrange from "../Asset/tick icon orange.png";
import shieldIconBlue from "../Asset/shield icon blue.png";
import plusIconOrange from "../Asset/plus icon orange.png";
import tickIconBlue from "../Asset/tick icon blue.png";
import shieldIconOrange from "../Asset/shield icon orange.png";
import Question_img from "../Asset/Question.png";
import vector_icon from "../Asset/Vector 4 .png";
import Wave from "../Asset/svgviewer-png-output.png";
import Arrow from "../Assets/Arrow.svg";
import logo1 from "../Asset/injured man illustration.png";
import logo2 from "../Asset/locker illustration.png";
import { ReactComponent as ArrowIcon } from "../Asset/up-arrow-svgrepo-com.svg";
import { Link } from "react-router-dom";
import GroupHealth from "../Assets/group health icon.svg";
import GroupPersonalAccident from "../Assets/group accident icon.svg";
import GroupTermLife from "../Assets/group term icon.svg";
import FireBulglary from "../Assets/fire & burglary icon.svg";
import OfficePackage from "../Assets/Icon office package.svg";
import ShopOwner from "../Assets/shop owner icon.svg";
import ProfDoctor from "../Assets/prof indemnity for doctors icon.svg";
import ProfCompanies from "../Assets/prof indemnity for companies icon.svg";
import Workmen from "../Assets/workmen compensation icon.svg";
import SingleTransit from "../Assets/single transit policy icon.svg";
import MarineOpen from "../Assets/marine open policy icon.svg";
import SalesTurnOver from "../Assets/sales turnover policy icon.svg";
import DirectorsOfficers from "../Assets/Directors & Office  Insurance icon.svg";
import ErrorOmmision from "../Assets/errors & omission icon.svg";
import GeneralLiability from "../Assets/general liability icon.svg";
import ProductLiabilty from "../Assets/Product Liability icon.svg";
import CyberInsurance from "../Assets/cyber icon.svg";
import CrimeInsurance from "../Assets/crime icon.svg";
import GroupGratulty from "../Assets/Group (4).svg";
import GroupCreditLife from "../Assets/Group (5).svg";
import MotorFleetInsurance from "../Assets/Group 9130.svg";
import tree from "../Assets/Group 8986.svg";
import tree1 from "../Assets/23849466_6815593 1.svg";
import innerplus from "../Assets/innerplus.svg";
const Section3 = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const questions = [
        {
            question: "Risk Mitigation",
            answer: "  SMEs face various risks in their day-to-day operations, including property damage, liability claims, and business interruptions. SME insurance provides a safety net by covering these risks, helping businesses recover and continue operations in the event of unforeseen events.",
        },
        {
            question: "Financial Protection",
            answer:
                " Insurance helps SMEs avoid significant financial losses resulting from unexpected events. Whether it's damage to property, lawsuits from third parties, or disruptions to business operations, having insurance coverage ensures that the financial impact is minimized, protecting the business's bottom line.",
        },
        {
            question: "Business Community",
            answer:
                "SME insurance ensures business continuity by providing funds for repairs, asset replacement, and lost income compensation after a disaster or unexpected event. This helps SMEs resume operations quickly, minimizing the impact on customers, suppliers, and employees.",
        },
        {
            question: "Compliance Peace of Mind",
            answer:
                "Many industries require SMEs to have certain types of insurance coverage to comply with regulations or contractual obligations. By having the appropriate insurance policies in place, SMEs can operate with confidence, knowing that they are meeting legal requirements and protecting their business interests.",
        },
    ];

    const toggleAnswer = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const handleButtonClick = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };
    return (
        <div>
            <div className="section3-container">
                <div className="section3-row1">
                    <img className="section3-icon1" src={plusIconBlue} alt="no" />
                    <p className="section3-heading1 section3-heading">
                        What is{" "}
                        <span className="section3-heading2 section3-heading">
                            SME Insurance ?
                        </span>
                    </p>
                    <img className="section3-icon2" src={tickIconOrange} alt="no" />
                </div>

                <div className="section3-row2">
                    <img className="section3-icon3" src={shieldIconBlue} alt="no" />
                    <img className="section3-image1" src={illustration} alt="no" />
                    <div className="section3-box">
                        <p>
                            SME insurance is like a <span style={{ fontWeight: '700' }}>personalized shield for small and
                                medium-sized businesses.</span> It's made to fit their specific needs,
                            <span style={{ fontWeight: '700' }}> protecting them from risks like property damage, liability issues,
                                and disruptions to their operations.</span> Think of it as a safety net
                            that gives business owners peace of mind, letting them focus on
                            running their business without worrying about unexpected setbacks.
                        </p>
                    </div>
                    <img className="section3-icon4" src={plusIconOrange} alt="no" />
                </div>
                <div className="section3-row3">
                    <img className="section3-icon5" src={tickIconBlue} alt="no" />
                    <img className="section3-icon6" src={shieldIconOrange} alt="no" />
                </div>
            </div>
        </div>
    )
}

export default Section3
